'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isolateSource = isolateSource;
exports.isolateSink = isolateSink;

var _util = require('../util');

function isolateSource(source, scope) {
  return source.select(_util.SCOPE_PREFIX + scope);
}

function isolateSink(sink, scope) {
  return sink.tap(function (vTree) {
    vTree.data.isolate = _util.SCOPE_PREFIX + scope;
  });
}


/** WEBPACK FOOTER **
 ** ./~/@motorcycle/dom/lib/isolate/isolation.js
 **/